import { Routes } from '@angular/router';

import { AdminNavigationGuard, AuthGuard } from '@emilegal/emi-fe-common';

export const routes: Routes = [
  {
    path: 'paga/:agentUID',
    loadComponent: () => import('./features/paga/paga').then((m) => m.PagaReview),
    canActivate: [AuthGuard],
    data: { hideNav: false },
  },
  // Cases shared by the project agents (complaint and the letters); the API calls them projects.
  {
    path: 'cases',
    loadComponent: () => import('./features/complaint/complaint-projects').then((m) => m.ComplaintProjects),
    canActivate: [AuthGuard],
    data: { hideNav: false },
  },
  {
    path: 'cases/:caseId',
    loadComponent: () => import('./features/complaint/complaint-project').then((m) => m.ComplaintProject),
    canActivate: [AuthGuard],
    data: { hideNav: false },
  },
  {
    path: 'cases/:caseId/runs/:executionId',
    loadComponent: () => import('./features/complaint/complaint-run').then((m) => m.ComplaintRun),
    canActivate: [AuthGuard],
    data: { hideNav: false },
  },
  {
    path: '',
    loadChildren: () => import('./features/landing-page/landing-page.routes').then((m) => m.routes),
    data: { hideNav: true, showHeader: true },
  },
  {
    path: 'login',
    loadChildren: () => import('@emilegal/emi-fe-common').then((m) => m.loginRoutes),
    data: { hideNav: true },
  },
  {
    path: 'admin-navigation',
    loadComponent: () => import('@emilegal/emi-fe-common').then((m) => m.AdminNavigation),
    data: { hideNav: true },
    canActivate: [AuthGuard, AdminNavigationGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.routes),
    data: { hideNav: false },
    canActivate: [AuthGuard],
  },
  {
    path: ':agentType/create-agent',
    loadChildren: () =>
      import('./features/create-agent/create-agents.routes').then((m) => m.createRoutes),
    data: { hideNav: true },
    canActivate: [AuthGuard],
  },
  {
    path: ':agentType/:agentUID/create-agent',
    loadChildren: () =>
      import('./features/create-agent/create-agents.routes').then((m) => m.editRoutes),
    data: { hideNav: true },
    canActivate: [AuthGuard],
  },
  {
    path: ':agentType/:agentUID/execute-agent',
    loadChildren: () =>
      import('./features/execute-agent/execute-agent.routes').then((m) => m.executeRoutes),
    data: { hideNav: true },
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '', // CREATE 404 PAGE
  },
];
